import script from "./ConnectButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ConnectButton.vue?vue&type=script&setup=true&lang=js"

import "./ConnectButton.vue?vue&type=style&index=0&id=0f07f9be&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f07f9be"]])

export default __exports__